<p>dashboard works!</p>
<div  style="width: 400px; height: 400px; border: 2px solid #ddd; padding: 10px; margin: 10px;" >
    <div class="mb-5">
        <app-review-analysis-chart></app-review-analysis-chart>
    </div>
   

 
 
</div>
